<div class="card">
    <div class="card-body">
        <h5 class="card-title main-blue">
            {{ "PurchaseEdit.acquiredSessions" | translate }}
        </h5>
        <div class="card-text">
            @for (week of weeks; track week) {
                <div class="voffset-20">
                    <div class="main-blue">{{ week.title }}</div>
                    @for (item of week.sessions; track item) {
                        <div>
                            <app-purchase-edit-session-item
                                [canRemoveOptions]="true"
                                [item]="item"
                                [purchaseSetId]="cart.purchaseSetId"
                            ></app-purchase-edit-session-item>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</div>
